import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader } from "baseui/modal";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import { IAutomationObject } from "../../../automationObjects";
import ObjectNavigator from "./ObjectNavigator";
import { ModalAutoSize } from "../../../components/ModalAutoSize";

export interface ObjectNavigatorModalProps {
    isOpen: boolean,
    setIsOpen: any,
    onSelected: any,
    showAddObject?: boolean,
    title: React.ReactNode,
    subTitle?: React.ReactNode,
    currentSelectedParent?: IAutomationObject,
    filter?: (app: IAutomationObject) => boolean | undefined,
}

const ObjectNavigatorModal = ({ onSelected, isOpen, setIsOpen, title, subTitle, showAddObject, currentSelectedParent, filter }: ObjectNavigatorModalProps) => {

    const [selectedItem1, setSeletctedItem1] = useState<IAutomationObject | undefined>(undefined);

    function onFinish() {
        onSelected(selectedItem1)
        setIsOpen(false);
    }
    function onCancel() {        setIsOpen(false);    }

    function onSelect(item: IAutomationObject) {
        setSeletctedItem1(item);
    }

    return (
        <ModalAutoSize
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            header={title}
            body={<>
                {subTitle}
                <ObjectNavigator filter={filter} showAddObject={showAddObject} onSelected={onSelect} currentSelectedParent={currentSelectedParent}></ObjectNavigator>
            </>}
            footer={<>
                <ModalButton kind="tertiary" onClick={onCancel}>
                    <FormattedMessage id="cancel" defaultMessage="Cancel" />
                </ModalButton>
                <ModalButton autoFocus onClick={onFinish}>  <FormattedMessage id="select" defaultMessage="Select" /></ModalButton>
            </>}
        ></ModalAutoSize>
    );
}

export default ObjectNavigatorModal;